var fees = {
  fees: {
    security_deposit: {
    id: "1",
    txt_id: "security_deposit",
    name: "Security Deposit",
    description: "A security deposit is returned to you in full if there is no damage to the unit.",
    fee_frequency_txt_id: "one_time",
    default_icon_location: null
    },
    pet_deposit: {
    id: "2",
    txt_id: "pet_deposit",
    name: "Pet Deposit",
    description: null,
    fee_frequency_txt_id: "one_time",
    default_icon_location: null
    },
    parking: {
    id: "3",
    txt_id: "parking",
    name: "Parking Space",
    description: null,
    fee_frequency_txt_id: "any",
    default_icon_location: null
    },
    storage: {
    id: "4",
    txt_id: "storage",
    name: "Storage",
    description: null,
    fee_frequency_txt_id: "any",
    default_icon_location: null
    },
    misc: {
    id: "5",
    txt_id: "misc",
    name: "Misc. Items",
    description: null,
    fee_frequency_txt_id: "any",
    default_icon_location: null
    }
  }
}

module.exports = fees
